document.addEventListener('DOMContentLoaded', function(){
    loadGalery();
});
function loadGalery(){
    const Gallery = document.querySelector('.imageList');
    for(let i = 1; i<=12; i++){
        const Image = document.createElement('IMG');
        Image.src = `/build/images/thumb/${i}.webp`;

        Image.dataset.imageId = i;
        
        //Evento Click en Imagen
        Image.onclick = clicImage;

        //ItemLista
        const List = document.createElement('LI');
        List.appendChild(Image);
        Gallery.appendChild(List);
    }
    //alert('Galeria cargada correctamente');
}

function clicImage(e){    
    //alert('Diste click en una Imagen ' + e.target.dataset.imageId);
    //generando imagen
    const id = e.target.dataset.imageId;
    const Image = document.createElement('IMG');
    Image.src = `/build/images/grande/${id}.webp`;
    Image.classList.add('thumbImage');
    
    //crear overlay para mostrar imagen
    const overlay = document.createElement('DIV');
    overlay.classList.add('overlay');    
    overlay.appendChild(Image);

    //mostrar en HTML
    const body = document.querySelector('body');
    body.appendChild(overlay);
    body.classList.add('fijarBody');

    //boton cerrar
    const closeBTN = document.createElement('P');
    closeBTN.textContent = 'X';
    closeBTN.classList.add('btnClose');
    closeBTN.onclick = function(){
        overlay.remove();
        body.classList.remove('fijarBody');
    };
    overlay.appendChild(closeBTN);
}